/**
 * The company behind WyseHub, as published in the AI Claims and WyseAi privacy notices:
 * the same controller, the same facts a regulator checks first. Kept in one place so the
 * notices cannot drift apart.
 */
export const COMPANY = {
  name: 'Wysehub Ltd',
  brand: 'WyseHub',
  address: '167-169 Great Portland Street, London, England, W1W 5PF',
  ico: '15820659',
  phone: '0333 880 9113',
} as const

/** The inbox every enquiry lands in, and the address offered as the way round the form. */
export const CONTACT_EMAIL = 'contact@wysehub.co.uk'

/** Where the enquiry form lives; the FAQ and the hero both link to it. */
export const CONTACT_PATH = '/contact'

/** Sign-in is a modal on the homepage, opened by this query. */
export const SIGN_IN_HREF = '/?login=true'

/**
 * The company's AI agency, on its own site. Linked from the header, the partner strip
 * and the footer, because WyseHub is the company name people search for and some of
 * them are looking for WyseAi.
 */
export const WYSEAI_URL = 'https://wyseai.co.uk'
